import { Injectable } from '@angular/core';

import { Router, Resolve, ActivatedRouteSnapshot } from '@angular/router';

import { AngularFireAuth } from 'angularfire2/auth';
import { first } from 'rxjs/operators';
import { GlobalService } from '../../../services/global.service';

@Injectable()
export class ChatResolverService {

  constructor(
    private _fireAuth: AngularFireAuth,
    private _router: Router,
    public _globalService: GlobalService,
  ) { }

  resolve(route: ActivatedRouteSnapshot): any {

    const path = this._globalService.root_path + '/' +
      this._globalService.getDomain(this._fireAuth.auth.currentUser.email) +
      '/users/' + this._fireAuth.auth.currentUser.uid;

   return this._globalService._fireDB.object(path)
      .valueChanges()
      .do( data => {
        // console.log('resolverrrrrrrrrrrrrrrrrr ', data);
        this._globalService.current_user_profile = data;
      })
      .first();


  }

}



// WEBPACK FOOTER //
// ./src/app/pages/chat/services/chat-resolver.service.ts